var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-spacer',{staticClass:"hidden-sm-and-down"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }